<template>
  <div class="pbc-post-card" :id="'p' + id">
    <div class="grow flex flex-col relative">
      <div class="pbc-post-user-box">
        <user :user='user' style='max-width: 12rem' class="flex-none text-white" :truncate='true' />
        <h2 class="pbc-post-title2 truncate">{{title}}</h2>
      </div>

      <pbc-post-play :id='id'
                :game='post.game'
                :start-pixi='visible'
                :fetch='fetch'
                :thumbnail='thumbnail'
                class="bg-gray-800 w-full flex-none"
                :ignore-global-pause='ignoreGlobalPause'
                :style='postStyle'
                :class='postClass'
                @view-post='$emit("view-post", post)'
                />

      <div v-if='false && parent.id !== "root"' class="pbc-post-title-box">
        <div class="pbc-post-remix-heading">remix of</div>
        <div class="my-auto">
          <h2 style='max-width:12rem;' class="pbc-post-title">{{truncate(parent.title)}}</h2>
        </div>
        <div class="text-xs text-gray-500 self-center mr-1">by</div>
        <user class="text-white" :user='parent.author' :truncate='true' />
      </div>
      <main-bar v-show='true'
                @click-download="onDownload" 
                @click-add="onAdd"
                @click-text="onText"
                @click-stickers="onStickers"
                @click-background="onBackground"
                @next='onRemix'
                :post='post'
                :type='post.type'
                :id='post.id'
                />


    </div>

  </div>

    <!--
      <pbc-button @click='share'
                  class="self-center h-12 flex-none text-center text-xs rounded bg-gray-300 text-black">
        <comment-multiple-outline :size='16'/>
          <span>
            {{replies.total}}
        </span>
      </pbc-button>
      -->

          <!--
          <p class="text-center mb-2">Comments</p>
          -->
</template>
<script>
import MainBar from '@ui/organisms/MainBar.vue';
//import VoteOnPost from '@ui/molecules/VoteOnPost.vue';
import CommentMultipleOutline from '@icons/CommentMultipleOutline.vue';

import User from '@ui/atoms/User.vue';
import Post from '@icons/Post.vue';
import EventEmitter from 'eventemitter3';
import gql from 'graphql-tag';
import { ApolloMutation } from 'vue-apollo';

import PbcPostPlay from '@ui/molecules/PbcPostPlay.vue';


export default {
  inject: ['api'],
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    upvotes: {
      type: Number,
      required: true
    },
    downvotes: {
      type: Number,
      required: true
    },
    parent: {
      type: Object,
      default() {
        return {
          id: 'root'
        }
      }
    },
    post:{
      type:Object,
      default() {
        return {}
      }
    },
    replies:{
      type:Object,
      default() {
        return {
          total: 0
        }
      }
    },
    visible: {
      type: Boolean,
      default: false
    },
    num:{
      type: Number,
      default: 0
    },
    fetch: {
      type: Boolean,
      required: false
    },
    ignoreGlobalPause:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const voteMutation = gql(`
      mutation votePost($id: String!, $type: String!) {
        votePost(id: $id, type: $type) {
          id
          upvotes
          downvotes
        }
      }
    `);

    return {
      voteMutation,
      votedData:{},
      postStyle:{}
    }
  },
  mounted() {
    const width = this.$el.getBoundingClientRect().width;
    const aspect = this.metadata.rows / this.metadata.cols;
    this.postStyle.height = (width * aspect) + 'px';
    this.postStyle['min-height'] = (width * aspect) + 'px';
  },
  components: {
    MainBar,
    PbcPostPlay,
    User,
  },
  methods:{
    onViewParent() {
      this.$router.push({
        name:'play',
        params:Object.assign({},
          this.$route.params,
        {
          id:this.parent.id,
        })
      });

    },
    onRemix() {
      this.$router.replace({
        hash:'#p' + this.id,
      });
      this.$router.push({
        hash:undefined,
        name:'start',
        params:{
          parentId:this.id,
          type:'post',
          __autoselect: false
        }
      });

      this.$ana.track({
        eventCategory:'nav',
        eventAction:'layout',
        extra:{
          post:this.id,
          type:"post"
        }
      });
    },
    onAdd() {
      this.edit("add");
    },
    onBackground() {
      this.edit("background");
    },
    onStickers() {
      this.edit("stickers");
    },
    onText() {
      this.edit("text");
    },

    edit(mode) {
      this.$router.replace({
        hash:'#p' + this.id,
      });
      this.$router.push({
        name:'start',
        hash:undefined,
        params:{
          parentId:this.id,
          type:'post',
        },
        query:{
          'mode':mode,
          'overlay':true
        }
      });
      this.$ana.track({
        eventCategory:'nav',
        eventAction:mode,
        extra:{
          post:this.id,
          type:"post"
        }
      });
    },
    truncate(title) {
      if (title.length >= 50) {
        return title.slice(0,47) + '...';
      } else {
        return title;
      }
    },
    async doVote(id, type, mutate) {
      const voted = await mutate({variables: {id, type}})
      this.votedData = {
        type
      }
      return voted;
    },
    reply() {
      this.$emit("reply");
    },
    onDownload() {
      if (this.$route.name === 'userposts') {
        this.$router.push({
          name:'downloadUserClip',
          params:{
            postId:this.id
          }
        });
      } else {
        // TODO: hack alert, fokken vue-router
        // there must be a better way?
        // i tried giving the two routes the same name (complains about duplicate names)
        // i also tried using just the path - this just always jumps you to hot
        const anyRouteIsNew = this.$route.matched.filter( ({name}) => {
          return name === 'new';
        }).length > 0;
        const anyRouteIsHot = this.$route.matched.filter( ({name}) => {
          return name === 'hot';
        }).length > 0;

        if (anyRouteIsNew) {
          this.$router.push({
            name:'downloadClipNew',
            params:{
              postId:this.id
            }
          });
        } else if (anyRouteIsHot) {
          this.$router.push({
            name:'downloadClipHot',
            params:{
              postId:this.id
            }
          });
        } else {
          console.error('vue-router sucks');
        }
      }
      //this.downloadClips = true;
    },
    upvote() {
    }
  },
  computed: {
    postClass() {
      const max = Math.min(this.metadata.rows, this.metadata.cols);

      const c = [this.metadata.cols / max, this.metadata.rows / max].map( (x) => {
        return Math.floor(x.toFixed(1) * 10) / 10
      }).map( (x) => {
        return (''+x).replace('.', '_')
      });
      const normalisedClass = 'pbc-post-play-' + c.join('x');
      return ['pbc-post-play', normalisedClass];
    },
    thumbnail() {
      if (this.post.clips.length) {
        const idx = 0;
        return this.post.clips[idx].thumbnail;
      } else {
        return null
      }
    },
    metadata() {
      return this.post.metadata || {cols:11,rows:16}
    },
    hasClip() {
      return this.post.clips.length > 0;
    },
    downloadStateHistoryName() {
      return 'ui--dlclip-' + this.id;
    },
  }
}
</script>

<style>

.pbc-post-title {
  @apply underline break-words text-xs font-bold self-center mr-1 text-white;
}

.pbc-post-remix-heading {
  @apply text-xs text-gray-500 self-center mr-1
}

.pbc-post-title-box {
  @apply pt-1 px-1 flex flex-row justify-center text-xs;
}

.pbc-post-user-box {
  @apply flex flex-row items-center ml-2 mt-1;
}

.pbc-post-title2 {
  @apply ml-2 text-white;
}

</style>
